import OgImg from '@/assets/images/workspace_metatag.png';
import '@/assets/sass/style.scss';
import Main from '@/components/Main';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

type CurrentHostType = 'docs.shopby.co.kr' | 'server-docs.shopby.co.kr';

const App = () => {
  const [currHost, setCurrHost] = useState<CurrentHostType>(window.location.host as CurrentHostType);
  const url = `https://www.googletagmanager.com/ns.html?id=${
    currHost === 'docs.shopby.co.kr' ? 'GTM-PRF2JS6' : 'GTM-WJVRB3F'
  }`;

  useEffect(() => {
    setCurrHost(window.location.host as CurrentHostType);
  }, []);
  return (
    <>
      <Helmet>
        <title>API 문서 {'<'} 워크스페이스ㅣNHN 커머스</title>
        <meta name="author" content="NHN커머스" />
        <meta
          name="keywords"
          content="샵바이, 개발자센터, 샵바이 개발자센터, 판매자센터, 샵바이 판매자센터, 워크스페이스, 샵바이디벨로퍼, 쇼핑몰제작, 쇼핑몰스킨제작, 쇼핑몰 기능개선, 쇼핑몰기능개발, 쇼핑몰개발, NHN커머스 워크스페이스"
        />
        <meta name="description" content="샵바이 솔루션에서 제공하는 API 입니다." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={OgImg} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:title" content="API 문서 < 워크스페이스 | NHN커머스" />
        <meta property="og:description" content="샵바이 솔루션에서 제공하는 API 입니다." />
        <meta property="og:url" content="https://www.nhn-commerce.com/" />
        <meta name="twitter:title" content="API 문서 < 워크스페이스 | NHN커머스" />
        <meta name="twitter:image" content={OgImg} />
        <meta name="twitter:description" content="샵바이 솔루션에서 제공하는 API 입니다." />
      </Helmet>
      <Main />
      <noscript>
        {`<iframe src=${url} height="0" width="0" style={{ display: 'none', visibility: 'hidden' }} />`}
      </noscript>
    </>
  );
};

export default App;
